import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  return (
    <>
      <Header />
      <section className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: January 2024</p>
        </div>
      </section>
      <section className="legal-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section-block">
              <h2>1. Information We Collect</h2>
              <p>When you use checkmycarhistory.com.au we collect the following information:</p>
              <ul>
                <li>Personal details: name, email address, phone number (optional)</li>
                <li>Payment information: processed securely by Stripe — we do not store card details</li>
                <li>Vehicle information: registration plate, VIN, state</li>
                <li>Technical data: IP address, browser type, device information, cookies</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>2. How We Use Your Information</h2>
              <p>We use your personal information to:</p>
              <ul>
                <li>Process your payment and generate your PPSR report</li>
                <li>Send your report to your nominated email address</li>
                <li>Provide customer support</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>3. Payment Information</h2>
              <p>All payments are processed by Stripe, a PCI DSS Level 1 certified payment processor. Your credit card details are never transmitted to or stored on our servers. For more information on how Stripe handles your payment data, please visit <a href="https://stripe.com/au/privacy" target="_blank" rel="noopener noreferrer">stripe.com/au/privacy</a>.</p>
            </div>

            <div className="legal-section-block">
              <h2>4. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties, except:</p>
              <ul>
                <li>To service providers necessary to operate our website (payment processing, report generation)</li>
                <li>When required by law or to respond to legal process</li>
                <li>To protect the rights, property, or safety of checkmycarhistory.com.au or our customers</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>5. Data Security</h2>
              <p>We implement appropriate technical and organisational measures to protect your personal information, including SSL/TLS encryption for all data transmission. However, no method of transmission over the internet is 100% secure and we cannot guarantee absolute security.</p>
            </div>

            <div className="legal-section-block">
              <h2>6. Your Rights</h2>
              <p>Under the Australian Privacy Act 1988 you have the right to:</p>
              <ul>
                <li>Access the personal information we hold about you</li>
                <li>Correct inaccurate or out-of-date information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt out of marketing communications</li>
              </ul>
              <p>To exercise these rights, please contact us at <Link to="/contact">contact form</Link>.</p>
            </div>

            <div className="legal-section-block">
              <h2>7. Cookies</h2>
              <p>We use cookies and similar technologies to improve your browsing experience and analyse website traffic. You can control cookie settings through your browser settings. Disabling cookies may affect the functionality of certain features.</p>
            </div>

            <div className="legal-section-block">
              <h2>8. Contact Us</h2>
              <p>If you have questions about this Privacy Policy, please contact us:</p>
              <ul>
                <li>Via our <Link to="/contact">contact form</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
